export default "__VITE_PUBLIC_ASSET__3a27f14f__"